{
  "list": {
    "title": "スマートフレーズ",
    "backToDashboard": "ダッシュボード",
    "newButton": "新規フレーズ",
    "import": "インポート",
    "export": "エクスポート",
    "searchPlaceholder": "キーまたは展開テキストで検索...",
    "filterAllCategories": "すべてのカテゴリ",
    "header": "フレーズ ({{count}})",
    "loading": "フレーズを読み込んでいます...",
    "empty": "フレーズが見つかりません。最初のスマートフレーズを作成してください。",
    "authoredBy": "作成者:{{name}}",
    "tooltips": {
      "preview": "プレビュー",
      "edit": "編集",
      "delete": "削除"
    },
    "confirmDelete": "確認",
    "cancelDelete": "キャンセル",
    "previewLabel": "プレビュー:",
    "closePreview": "プレビューを閉じる",
    "toast": {
      "deleted": "フレーズを削除しました",
      "importComingSoon": "インポート機能は近日提供予定",
      "exportComingSoon": "エクスポート機能は近日提供予定"
    }
  },
  "form": {
    "editTitle": "スマートフレーズを編集",
    "createTitle": "新規スマートフレーズ",
    "fields": {
      "key": "キー",
      "category": "カテゴリ",
      "expansionText": "展開テキスト"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "\".\" で始める必要があります",
    "categoryUncategorized": "未分類",
    "expansionPlaceholder": "ショートカットを置き換えるテキストを入力...",
    "cancel": "キャンセル",
    "create": "フレーズを作成",
    "update": "フレーズを更新",
    "toast": {
      "created": "フレーズを作成しました",
      "updated": "フレーズを更新しました",
      "saveFailed": "フレーズの保存に失敗しました",
      "keyMustStartWithDot": "キーは \".\" で始める必要があります",
      "keyTooShort": "キーは 2 文字以上必要です",
      "expansionRequired": "展開テキストを入力してください"
    }
  },
  "category": {
    "general": "一般",
    "physicalExam": "身体所見",
    "reviewOfSystems": "システムレビュー",
    "assessment": "アセスメント",
    "plan": "プラン",
    "instructions": "指示",
    "medications": "薬剤",
    "history": "既往歴"
  }
}
